import { Graph, LampCharge, Strongbox2 } from 'iconsax-react';
import type { ReactNode } from 'react';

import { GoldBars } from '@shared/ui';

import { TInvestmentBannerType } from '../model/bannerTypes';

export const InvestmentBannerIcons: Record<TInvestmentBannerType, ReactNode> = {
  gold: <GoldBars size={24} className='text-pics' />,
  smart: <LampCharge size={24} variant='Bold' className='text-turquoise' />,
  funds: <Strongbox2 size={24} variant='Bold' className='text-blue-1' />,
  portfolio: <Graph size={24} variant='Bold' className='text-purple' />,
  consulting: <Graph size={24} variant='Bold' className='text-purple' />,
};
